import { Component, OnInit } from '@angular/core';
import { Instance, InstanceService } from '../instance.service';
import { AuthService } from '../auth.service';
import { PageEvent } from '@angular/material/paginator';
import { PageResponse } from '../base-capacitor-http';
import { UtilitieService } from 'src/app/services/utils/utilities.service';
import { WebsocketService } from 'src/app/services/utils/websocket.service';

@Component({
  selector: 'instance',
  templateUrl: './instance.component.html',
  styleUrls: ['./instance.component.css']
})
export class InstanceComponent implements OnInit {

  page: PageResponse<Instance>;
  pageSize: number = 10;
  pageIndex: number = 0;
  activeInstance: Instance;
  modal: boolean = false;
  toast: boolean = false;
  selectedInstance: number = null;
  modalInstance: Instance;
  toastTitle: string = '';
  toastMessage: string = '';
  // Type icons (using emojis for simplicity)
  typeIcons = {
    'Database': '🗄️',
    'Compute': '💻',
    'Storage': '💾',
    'Cache': '⚡'
  };

  constructor(private instanceService: InstanceService, private authService: AuthService, private utilService: UtilitieService, private webSocketService: WebsocketService) {

  }
  showModal() {
    this.modal = true;
  }
  hideModal() {
    this.modal = false;
  }

  showToast(title: string, message: string) {
    this.toastTitle = title;
    this.toastMessage = message;
    this.toast = true;
    setTimeout(() => {
      this.toast = false;
      this.toastTitle = '';
      this.toastMessage = '';

    }, 5000);
  }
  hideToast() {
    this.toast = false;
  }

  async addInstance() {
    if (this.page.totalItems > 1) {
      return;
    }
    const authResponse = await this.instanceService.createInstance(this.modalInstance.name);
    if (authResponse) {
      this.loadPageData();
      this.modal = false;
      this.showToast('Instance added', 'Instance has been added.');
    }
  }

  async removeInstance() {

  }

  async toggleDropdown(instanceId: number) {
    if (this.selectedInstance === instanceId) {
      this.selectedInstance = null;
      return;
    }
    this.selectedInstance = instanceId;
  }

  async handleInstanceAction(index: number, action: string) {
    const instance = this.page.data[index];
    let update: Instance;

    switch (action) {
      case 'switch':
        const authResponse = await this.instanceService.switchInstance(instance.id);
        if (authResponse) {
          //this.authService.storeAuthToken(authResponse);
          this.authService.updateAuthState(authResponse);
          this.activeInstance = instance;
          this.showToast('Instance switched', 'ok');
        }
        break;
      case 'start':
        instance.status = 'ACTIVE';
        update = await this.instanceService.updateInstance(instance);
        if (update) {
          this.page.data[index] = update;
          this.showToast('Instance Updated', 'Instance status has been updated');
        }
        break;
      case 'stop':
        instance.status = 'STOPPED';
        update = await this.instanceService.updateInstance(instance);
        if (update) {
          this.page.data[index] = update;
          this.showToast('Instance Updated', 'Instance status has been updated');
        }
        break;
      case 'data':
        instance.status = 'ACTIVE';
        const confirmation = await this.utilService.openConfirmationDialog('Data upload', 'This will remove any existing data and update it with new uploaded data. Old data cannot not be recovered');
        if (confirmation) {
          let yardData = await this.instanceService.openCreateInstanceDialog(instance.id);
          if (yardData) {
            yardData = await this.instanceService.addInstanceData(instance.id, yardData);
            this.showToast('Instance Updated', 'Data yard data has been added to instance');
          }
        }

        break;
      case 'delete':
        const deleteResult = await this.instanceService.deleteInstance(instance.id);
        if (deleteResult) {
          this.page.data.splice(index, 1);
          this.showToast('Deleted Instance', 'Instance ' + instance.name + ' has been removed');
        }
        break;
      default:
        break;
    }

  }

  async switchInstance(instanceId: number) {
    const authResponse = await this.instanceService.switchInstance(instanceId);
    if (authResponse) {
      await this.authService.storeAuthToken(authResponse);
      const instance = this.page.data.find(instance => instance.id === instanceId);
      this.showToast("Instance switched", "Switched to instance " + instance.name);
    }
  }


  async handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.loadPageData();
  }

  async loadPageData() {
    this.page = await this.instanceService.getUserInstances(this.pageIndex, this.pageSize, null);
    const instanceId = await this.authService.getActiveInstance();
    this.activeInstance = this.page.data.find(instance => instance.id === instanceId);
  }



  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.modalInstance = new Instance();
    this.page = new PageResponse();
    await this.loadPageData();
    this.utilService.updateLoading(false);

  }

}
